import script from "./ChatAI.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatAI.vue?vue&type=script&setup=true&lang=js"

import "./ChatAI.vue?vue&type=style&index=0&id=61a88509&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a88509"]])

export default __exports__